export default class AddressObj {
    zip
    street
    state
    number
    neighborhood
    complement
    city
}
